import { PropsWithChildren, useEffect } from "react";
import tw, { styled } from "twin.macro";
import * as Sentry from "@sentry/react";

import { useAppState } from "app/providers/AppStateProvider";
import {
  //   BUSHA_LOGO,
  //   BUSHA_PRIVACY_URL,
  //   BUSHA_TERMS_URL,
  //   BUSHA_URL,
  INITIALIZED_STATUS,
} from "app/constants/variables";
import Text from "app/styles/Text";
import ErrorWidget from "./ErrorWidget";
import LoaderContainer from "./LoaderContainer";
import { BUSHA_ROOT, PAYMENT_PAGE, TRANSFER_ROOT } from "app/constants/routes";
import { Navigate } from "react-router-dom";
import useIsFirstRender from "app/hooks/useIsFirstRender";

export default function RoutesWrapper(props: PropsWithChildren<{}>) {
  const { paymentComplete, mode, displayMode, parentOrigin, paymentMethod } =
    useAppState();

  useEffect(() => {
    if (displayMode === "INLINE" && parentOrigin) {
      const target = window.parent;

      target.postMessage(
        {
          status: INITIALIZED_STATUS,
        },
        parentOrigin
      );
    }
  }, [displayMode, parentOrigin]);

  const isFirstRender = useIsFirstRender();

  if (paymentMethod === "TRANSFER" && isFirstRender) {
    return <Navigate to={`${TRANSFER_ROOT}/${PAYMENT_PAGE}`} />;
  } else if (paymentMethod === "BUSHA" && isFirstRender) {
    return <Navigate to={BUSHA_ROOT} />;
  }

  return (
    <Container $isInline={displayMode === "INLINE"}>
      {mode === "test" && (
        <TestModeBanner>
          <Text tw="text-[#FF8600]">
            This is a test payment link where you can test how this feature
            works
          </Text>
        </TestModeBanner>
      )}
      <Sentry.ErrorBoundary
        fallback={ErrorWidget}
        beforeCapture={(scope) => {
          scope.setTag("location", "app");
        }}
      >
        <LoaderContainer
          css={
            [
              // tw`max-w-[480px] w-full h-full`,
              // !isConnected && tw`justify-center min-h-[283px] rounded-[12px]`,
            ]
          }
        // loading={!isConnected}
        >
          {!paymentComplete && props.children}
        </LoaderContainer>
      </Sentry.ErrorBoundary>
      {/* <Footer>
        <div tw="flex items-center">
          <Text>Secured by</Text>

          <a href={BUSHA_URL} target="_blank" rel="noopener noreferrer">
            <img src={BUSHA_LOGO} alt="Busha" />
          </a>
        </div>

        <div tw="h-[18px] w-[1px] bg-[#CFCFD0]" />

        <a href={BUSHA_TERMS_URL} target="_blank" rel="noopener noreferrer">
          Terms
        </a>

        <a href={BUSHA_PRIVACY_URL} target="_blank" rel="noopener noreferrer">
          Privacy
        </a>
      </Footer> */}
    </Container>
  );
}

const Container = styled.main<{ $isInline?: boolean }>`
  ${tw`min-h-screen w-full flex flex-col items-center justify-center mobile:px-[16px] h-screen`};
  ${({ $isInline }) => !$isInline && tw`bg-containment-primary`};
`;

const TestModeBanner = tw.div`max-w-[480px] w-full py-[16px] mb-[16px] rounded-[8px] bg-[#FFF3E6] flex items-center justify-center text-center mobile:px-[16px]`;

// const Footer = styled.div`
//   ${tw`flex gap-[16px] items-center mt-[16px] text-[1.4rem]`};

//   img {
//     ${tw`ml-[8px] h-[16px]`};
//   }
// `;
